import { UserModel } from './model/user-registration.model';
import { Injectable } from '@angular/core';
import { HandlerService } from '../comunicator-native/handler/handler';
import { UserRegistrationDataService } from './user-registration-data.service';

@Injectable({
  providedIn: 'root'
})
export class UserRegistrationDataMobileService implements UserRegistrationDataService{

  constructor(private handlerService: HandlerService) {}

  public getUserRegistration(): Promise<UserModel> {
    const relCaronte = 'user-cad-data';

    return this.handlerService.caronteCommunicator(relCaronte).then((data: any) => {
      if (data) {
        return Promise.resolve(data);
      } else{
        console.error(data);
      }
    });
  }
}

